export const TABLE_PAGE_SIZE = 10;

export const TABLE_PAGINATION = {
  position: ["bottomCenter"],
  pageSize: TABLE_PAGE_SIZE,
  showSizeChanger: false,
};

export const LIST_PAGINATION = {
  position: "bottom",
  align: "center",
  pageSize: TABLE_PAGE_SIZE,
  showSizeChanger: false,
};

export const DEAL_CARD_PAGE_SIZE = 9;
